import { createReducer, on } from '@ngrx/store';
import { createEmptyStateResource, createStateResource, StateResource } from '@schir-int-client/ngrx-helpers';
import {
	createAlternativeTextEntryAction,
	createAlternativeTextEntrySuccessAction,
	deleteAlternativeTextEntryAction,
	deleteAlternativeTextEntrySuccessAction,
	loadAlternativeTexteAction,
	loadAlternativeTexteSuccessAction,
	updateAlternativeTextEntryAction,
	updateAlternativeTextEntrySuccessAction,
} from './alternative-text.actions';
import { AlternativeTextLinkrel } from './alternative-text.linkrel';
import { AlternativeTextListResource, AlternativeTextResource } from './alternative-text.model';
import { loadVerfahrenSingleSuccessAction } from '@schir-int-client/verfahren-shared';
import { getId } from '../../../test-helpers/src/lib/resource-helper';

export interface AlternativeTextState {
	alternativeTexte: StateResource<AlternativeTextListResource>;
	alternativeTextByChangeEntry: {
		[changeEntryId: string]: StateResource<AlternativeTextResource>;
	};
}

export const initialState: AlternativeTextState = {
	alternativeTexte: createEmptyStateResource(),
	alternativeTextByChangeEntry: {},
};

export const alternativeTextReducer = createReducer(
	initialState,
	// change to NAVIGATED when selecting verfahren is using navigation
	on(loadVerfahrenSingleSuccessAction, (state: AlternativeTextState): AlternativeTextState => ({
		...state,
		alternativeTexte: createEmptyStateResource(),
		alternativeTextByChangeEntry: {},
	})),
	on(loadAlternativeTexteAction, (state: AlternativeTextState): AlternativeTextState => ({
		...state,
		alternativeTexte: createEmptyStateResource(true),
	})),
	on(
		loadAlternativeTexteSuccessAction,
		(state: AlternativeTextState, { alternativeTexte }): AlternativeTextState => ({
			...state,
			alternativeTexte: createStateResource(alternativeTexte),
		})
	),
	on(
		createAlternativeTextEntryAction,
		(state: AlternativeTextState, { flaggenrechtResource }): AlternativeTextState => ({
			...state,
			alternativeTextByChangeEntry: {
				...state.alternativeTextByChangeEntry,
				[getId(flaggenrechtResource)]: createEmptyStateResource(true),
			},
		})
	),
	on(
		createAlternativeTextEntrySuccessAction,
		(state: AlternativeTextState, { alternativeTextResource }): AlternativeTextState => ({
			...state,
			alternativeTextByChangeEntry: {
				...state.alternativeTextByChangeEntry,
				[getId(alternativeTextResource, AlternativeTextLinkrel.SPALTEN_EINTRAG)]:
					createStateResource(alternativeTextResource),
			},
		})
	),
	on(
		updateAlternativeTextEntryAction,
		(state: AlternativeTextState, { alternativeTextResource }): AlternativeTextState => ({
			...state,
			alternativeTextByChangeEntry: {
				...state.alternativeTextByChangeEntry,
				[getId(alternativeTextResource, AlternativeTextLinkrel.SPALTEN_EINTRAG)]:
					createEmptyStateResource(true),
			},
		})
	),
	on(
		updateAlternativeTextEntrySuccessAction,
		(state: AlternativeTextState, { alternativeTextResource }): AlternativeTextState => ({
			...state,
			alternativeTextByChangeEntry: {
				...state.alternativeTextByChangeEntry,
				[getId(alternativeTextResource, AlternativeTextLinkrel.SPALTEN_EINTRAG)]:
					createStateResource(alternativeTextResource),
			},
		})
	),
	on(
		deleteAlternativeTextEntryAction,
		(state: AlternativeTextState, { alternativeTextResource }): AlternativeTextState => ({
			...state,
			alternativeTextByChangeEntry: {
				...state.alternativeTextByChangeEntry,
				[getId(alternativeTextResource, AlternativeTextLinkrel.SPALTEN_EINTRAG)]:
					createEmptyStateResource(true),
			},
		})
	),
	on(
		deleteAlternativeTextEntrySuccessAction,
		(state: AlternativeTextState, { alternativeTextResource }): AlternativeTextState => {
			const newState = { ...state };
			delete newState.alternativeTextByChangeEntry[
				getId(alternativeTextResource, AlternativeTextLinkrel.SPALTEN_EINTRAG)
			];
			return newState;
		}
	)
);
